export const worksheets68 = [
  // Grade 6
  {
    id: 'g6-ratios-rates',
    title: 'Ratios and Rates',
    description: 'Understand and apply ratios, rates, and unit rates to solve real-world problems.',
    grade: 'Grade 6',
    subject: 'Math',
    topic: 'Ratios',
    difficulty: 'Intermediate',
    pages: 6,
    isFree: true,
    downloadUrl: '/downloads/g6-ratios-rates.pdf',
    thumbnailUrl: 'https://public.readdy.ai/ai/img_res/1eb6108935d202c1867ab7bee5733f44.jpg'
  },
  {
    id: 'g6-percent-problems',
    title: 'Percent Problems',
    description: 'Calculate percentages, find percent of a number, and solve discount and tax problems.',
    grade: 'Grade 6',
    subject: 'Math',
    topic: 'Percents',
    difficulty: 'Intermediate',
    pages: 5,
    isFree: true,
    downloadUrl: '/downloads/g6-percent-problems.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=sixth%20grade%20percent%20worksheet%20with%20percentage%20calculations%2C%20discount%20problems%2C%20tax%20and%20tip%20scenarios%2C%20visual%20percent%20models%2C%20educational%20math%20design%2C%20clean%20white%20background&width=400&height=500&seq=g602&orientation=portrait'
  },
  {
    id: 'g6-integers-operations',
    title: 'Integer Operations',
    description: 'Add, subtract, multiply, and divide integers using number lines and rules.',
    grade: 'Grade 6',
    subject: 'Math',
    topic: 'Integers',
    difficulty: 'Intermediate',
    pages: 6,
    isFree: true,
    downloadUrl: '/downloads/g6-integers-operations.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=sixth%20grade%20integers%20worksheet%20with%20positive%20and%20negative%20numbers%2C%20number%20lines%2C%20integer%20operations%2C%20addition%20subtraction%20multiplication%20division%2C%20educational%20math%20design%2C%20clean%20background&width=400&height=500&seq=g603&orientation=portrait'
  },
  {
    id: 'g6-expressions-equations',
    title: 'Expressions and Equations',
    description: 'Write and evaluate algebraic expressions, solve one-step equations.',
    grade: 'Grade 6',
    subject: 'Math',
    topic: 'Algebra',
    difficulty: 'Intermediate',
    pages: 6,
    isFree: true,
    downloadUrl: '/downloads/g6-expressions-equations.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=sixth%20grade%20algebra%20worksheet%20with%20algebraic%20expressions%2C%20variables%2C%20one%20step%20equations%2C%20solving%20for%20x%2C%20organized%20problem%20layout%2C%20educational%20math%20design%2C%20clean%20white%20background&width=400&height=500&seq=g604&orientation=portrait'
  },
  {
    id: 'g6-area-polygons',
    title: 'Area of Polygons',
    description: 'Find area of triangles, quadrilaterals, and composite figures using formulas.',
    grade: 'Grade 6',
    subject: 'Math',
    topic: 'Geometry',
    difficulty: 'Intermediate',
    pages: 5,
    isFree: true,
    downloadUrl: '/downloads/g6-area-polygons.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=sixth%20grade%20geometry%20worksheet%20with%20polygons%2C%20triangles%2C%20trapezoids%2C%20area%20formulas%2C%20labeled%20dimensions%2C%20composite%20shapes%2C%20educational%20geometric%20design%2C%20clean%20simple%20background&width=400&height=500&seq=g605&orientation=portrait'
  },

  // Grade 7
  {
    id: 'g7-proportional-relationships',
    title: 'Proportional Relationships',
    description: 'Analyze proportional relationships using tables, graphs, and equations.',
    grade: 'Grade 7',
    subject: 'Math',
    topic: 'Proportions',
    difficulty: 'Intermediate',
    pages: 6,
    isFree: true,
    downloadUrl: '/downloads/g7-proportional-relationships.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=seventh%20grade%20proportions%20worksheet%20with%20ratio%20tables%2C%20coordinate%20graphs%2C%20proportional%20relationships%2C%20constant%20of%20proportionality%2C%20educational%20math%20design%2C%20clean%20organized%20background&width=400&height=500&seq=g701&orientation=portrait'
  },
  {
    id: 'g7-multi-step-equations',
    title: 'Multi-Step Equations',
    description: 'Solve multi-step equations with variables on both sides and distributive property.',
    grade: 'Grade 7',
    subject: 'Math',
    topic: 'Algebra',
    difficulty: 'Intermediate',
    pages: 6,
    isFree: true,
    downloadUrl: '/downloads/g7-multi-step-equations.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=seventh%20grade%20algebra%20worksheet%20with%20multi%20step%20equations%2C%20variables%20on%20both%20sides%2C%20distributive%20property%2C%20combining%20like%20terms%2C%20organized%20problem%20layout%2C%20educational%20design%2C%20clean%20background&width=400&height=500&seq=g702&orientation=portrait'
  },
  {
    id: 'g7-inequalities',
    title: 'Solving Inequalities',
    description: 'Solve and graph one and two-step inequalities on number lines.',
    grade: 'Grade 7',
    subject: 'Math',
    topic: 'Inequalities',
    difficulty: 'Intermediate',
    pages: 5,
    isFree: true,
    downloadUrl: '/downloads/g7-inequalities.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=seventh%20grade%20inequalities%20worksheet%20with%20inequality%20symbols%2C%20number%20lines%20with%20open%20and%20closed%20circles%2C%20solving%20inequalities%2C%20graphing%20solutions%2C%20educational%20math%20design%2C%20clean%20white%20background&width=400&height=500&seq=g703&orientation=portrait'
  },
  {
    id: 'g7-probability',
    title: 'Probability and Statistics',
    description: 'Calculate theoretical and experimental probability, analyze data distributions.',
    grade: 'Grade 7',
    subject: 'Math',
    topic: 'Probability',
    difficulty: 'Intermediate',
    pages: 5,
    isFree: true,
    downloadUrl: '/downloads/g7-probability.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=seventh%20grade%20probability%20worksheet%20with%20dice%2C%20spinners%2C%20tree%20diagrams%2C%20sample%20spaces%2C%20data%20tables%2C%20statistical%20analysis%2C%20colorful%20educational%20design%2C%20clean%20organized%20background&width=400&height=500&seq=g704&orientation=portrait'
  },
  {
    id: 'g7-circles-circumference',
    title: 'Circles: Area and Circumference',
    description: 'Calculate area and circumference of circles using pi and solve real-world problems.',
    grade: 'Grade 7',
    subject: 'Math',
    topic: 'Geometry',
    difficulty: 'Intermediate',
    pages: 5,
    isFree: true,
    downloadUrl: '/downloads/g7-circles-circumference.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=seventh%20grade%20circles%20worksheet%20with%20circle%20diagrams%2C%20radius%20and%20diameter%2C%20pi%20symbol%2C%20area%20and%20circumference%20formulas%2C%20labeled%20measurements%2C%20educational%20geometry%20design%2C%20clean%20background&width=400&height=500&seq=g705&orientation=portrait'
  },

  // Grade 8
  {
    id: 'g8-linear-equations',
    title: 'Linear Equations and Slope',
    description: 'Graph linear equations, find slope, and write equations in slope-intercept form.',
    grade: 'Grade 8',
    subject: 'Math',
    topic: 'Linear Equations',
    difficulty: 'Intermediate',
    pages: 6,
    isFree: true,
    downloadUrl: '/downloads/g8-linear-equations.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=eighth%20grade%20linear%20equations%20worksheet%20with%20coordinate%20planes%2C%20graphing%20lines%2C%20slope%20calculations%2C%20y%20equals%20mx%20plus%20b%2C%20organized%20problem%20layout%2C%20educational%20math%20design%2C%20clean%20background&width=400&height=500&seq=g801&orientation=portrait'
  },
  {
    id: 'g8-systems-equations',
    title: 'Systems of Equations',
    description: 'Solve systems of linear equations using graphing, substitution, and elimination.',
    grade: 'Grade 8',
    subject: 'Math',
    topic: 'Systems',
    difficulty: 'Advanced',
    pages: 6,
    isFree: true,
    downloadUrl: '/downloads/g8-systems-equations.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=eighth%20grade%20systems%20of%20equations%20worksheet%20with%20two%20equations%2C%20coordinate%20graphs%20showing%20intersections%2C%20substitution%20and%20elimination%20methods%2C%20organized%20solution%20steps%2C%20educational%20design%2C%20clean%20white%20background&width=400&height=500&seq=g802&orientation=portrait'
  },
  {
    id: 'g8-exponents-scientific',
    title: 'Exponents and Scientific Notation',
    description: 'Apply exponent rules and work with numbers in scientific notation.',
    grade: 'Grade 8',
    subject: 'Math',
    topic: 'Exponents',
    difficulty: 'Intermediate',
    pages: 5,
    isFree: true,
    downloadUrl: '/downloads/g8-exponents-scientific.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=eighth%20grade%20exponents%20worksheet%20with%20power%20rules%2C%20scientific%20notation%2C%20large%20and%20small%20numbers%2C%20exponent%20operations%2C%20organized%20problem%20layout%2C%20educational%20math%20design%2C%20clean%20background&width=400&height=500&seq=g803&orientation=portrait'
  },
  {
    id: 'g8-pythagorean-theorem',
    title: 'Pythagorean Theorem',
    description: 'Apply the Pythagorean theorem to find missing sides and solve real-world problems.',
    grade: 'Grade 8',
    subject: 'Math',
    topic: 'Geometry',
    difficulty: 'Intermediate',
    pages: 5,
    isFree: true,
    downloadUrl: '/downloads/g8-pythagorean-theorem.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=eighth%20grade%20Pythagorean%20theorem%20worksheet%20with%20right%20triangles%2C%20a%20squared%20plus%20b%20squared%20equals%20c%20squared%20formula%2C%20labeled%20sides%2C%20real%20world%20applications%2C%20educational%20geometry%20design%2C%20clean%20background&width=400&height=500&seq=g804&orientation=portrait'
  },
  {
    id: 'g8-transformations',
    title: 'Geometric Transformations',
    description: 'Perform translations, rotations, reflections, and dilations on coordinate planes.',
    grade: 'Grade 8',
    subject: 'Math',
    topic: 'Transformations',
    difficulty: 'Intermediate',
    pages: 6,
    isFree: true,
    downloadUrl: '/downloads/g8-transformations.pdf',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=eighth%20grade%20transformations%20worksheet%20with%20coordinate%20grids%2C%20shapes%20being%20translated%20rotated%20reflected%2C%20geometric%20transformations%2C%20before%20and%20after%20images%2C%20educational%20geometry%20design%2C%20clean%20organized%20background&width=400&height=500&seq=g805&orientation=portrait'
  }
];